import { getFreeArticles } from "@/data/launchKitArticles";

export interface DocsArticle {
  id: string;
  title: string;
  category: string;
}

const launchKitDocsArticles: DocsArticle[] = getFreeArticles().map((a) => ({
  id: a.id,
  title: a.title,
  category: "Turo Hosting Basics",
}));

export const docsArticles: DocsArticle[] = [
  {
    id: "about-hostcaptain",
    title: "About HostCaptain",
    category: "Company",
  },
  {
    id: "our-approach",
    title: "Our Approach",
    category: "Company",
  },
  // Getting Started section
  {
    id: "getting-started-dashboard",
    title: "Dashboard Overview",
    category: "Getting Started",
  },
  {
    id: "getting-started-earnings",
    title: "Importing Earnings",
    category: "Getting Started",
  },
  {
    id: "getting-started-expenses",
    title: "Tracking Expenses",
    category: "Getting Started",
  },
  {
    id: "getting-started-vehicles",
    title: "Managing Vehicles",
    category: "Getting Started",
  },
  {
    id: "getting-started-recurring-expenses",
    title: "Recurring Expenses & Loans",
    category: "Getting Started",
  },
  {
    id: "getting-started-maintenance",
    title: "Maintenance Tracking",
    category: "Getting Started",
  },
  {
    id: "getting-started-captain-ai",
    title: "Captain AI Assistant",
    category: "Getting Started",
  },
  {
    id: "getting-started-team-settings",
    title: "Team & Settings",
    category: "Getting Started",
  },
  ...launchKitDocsArticles,
];

export const getDocsArticleById = (id: string): DocsArticle | undefined => {
  return docsArticles.find((a) => a.id === id);
};
